import "./MarketPlaceRanking.css";

const MarketPlaceRanking = ({ communityRanking, totalCommunities }) => {
  return (
    <div className="MarketPlaceRankingBox">
      <div className="">
        <p className={`MarketPlacetitle MarketPlaceleaderTitle`}>
          Your Ranking
        </p>
        <div className="MarketPlaceCircle">
          <p className="MarketPlaceNumbers">{`${communityRanking}/${totalCommunities}`}</p>
        </div>
        <p className="MarketPlaceSubText">Amongst all trading groups</p>
      </div>
    </div>
  );
};

export default MarketPlaceRanking;
